import { useLayoutEffect } from 'react';
import { writePwaSession } from 'utils';
// useLayoutEffect (not useEffect) so the sessionStorage write completes during
// commit, before paint. Otherwise a user could click "Pay With Alphaeon" and
// reach Find My Account before the session is written; FMA would default to
// fma_marketing and useFmaChannel reads sessionStorage once on render.
export function usePwaChannel(channel, locationId) {
    useLayoutEffect(() => {
        writePwaSession({ channel, locationId });
    }, [channel, locationId]);
}
